// src/hooks/useCurrentUrl.ts
import { useLocation, useParams } from "react-router";

/**
 * useCurrentUrl
 * 現在の URL に関する情報をまとめて返すユーティリティフック
 */
export function useCurrentUrl() {
  const location = useLocation();
  const params = useParams();

  // クエリパラメータ (?key=value)
  const query = new URLSearchParams(location.search);

  // ハッシュパラメータ (#key=value)
  const hashParams = new URLSearchParams(location.hash.replace(/^#/, ""));

  return {
    /** フルURL (window.location.href 全体) */
    url: window.location.href,

    /** React Router の location オブジェクト */
    location,

    /** パス (/product/:id 等) */
    path: location.pathname,

    /** 動的パラメータ（React Router の params） */
    params,

    /** クエリパラメータ オブジェクト */
    query,

    /** ハッシュパラメータ オブジェクト */
    hash: location.hash,

    /** ハッシュをパースした key-value */
    hashParams,
  };
}
